
<div *ngIf="data.length > 0">
    <valg-table
        [columnDefinition]="candidateListColumnDef"
        [data]="data"
        [itemName]="'candidate_mandates.item_name' | translate"
        [title]="'candidate_mandates.title' | translate"
        [hasPagination]="false"
        [displayItemCount]="false"
        [hasMainActionButton]="false">
        <h2 class="m-0 text--f20 text--500">{{ 'candidate_mandates.title' | translate }}</h2>
        <valg-dk-result-summary content-position="pre-table" [resultSummary]="resultSummary" *ngIf="!basedOnMissingResults"></valg-dk-result-summary>
        <div color="error-gray" valg-message-bar *ngIf="basedOnMissingResults">
          <span class="text--500">{{ 'mandates_list.errors.based_on_missing_results.title' | translate }} </span>
          <span>{{ 'mandates_list.errors.based_on_missing_results.message'  | translate }}</span>
      </div>
    </valg-table>
</div>
<div *ngIf="data.length === 0" class="p-5">
  <h2 class="mt-0 text--f20 text--500">{{ 'candidate_mandates.title' | translate }}</h2>
  {{"candidate_mandates.no_data_description" | translate}}
</div>

